// extracted by mini-css-extract-plugin
export default {"grid":"HistoryQuadImages_grid__7vIL8","cell":"HistoryQuadImages_cell__wgxDj","elevated":"HistoryQuadImages_elevated__RY6xL","image":"HistoryQuadImages_image__Egmrs"};